export default __webpack_public_path__ + "static/media/logo-deltadental.1d5d7a1b.png";